<app-question-card>
  <p question *ngIf="!editMode && approxHomeWorth">Sounds good!</p>
  <p class="desc" question *ngIf="!editMode && approxHomeWorth && journeyType === FelloOfferJourneyType.LWF;">
    <br />We'll connect you with highly-rated agents who specialize in homes like yours!
  </p>
  <p class="desc" question *ngIf="!editMode && approxHomeWorth"><br />How much do you think the home is worth?</p>
  <div class="form-field" input-options *ngIf="!editMode">
    <div class="radio-option-arrow" *ngIf="approxHomeWorth">
      <input type="radio" [id]="lowerRange" name="home-cost" [value]="lowerRange" (click)="submit(lowerRange)" [(ngModel)]="homeWorth" />
      <label [for]="lowerRange">
        {{lowerRange}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="bold" fontSize="22">right</app-icon>
      </label>
    </div>
    <div class="radio-option-arrow" *ngIf="approxHomeWorth">
      <input type="radio" [id]="upperRange" name="home-cost" [value]="upperRange" (click)="submit(upperRange)" [(ngModel)]="homeWorth" />
      <label [for]="upperRange">
        {{upperRange}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="bold" fontSize="22">right</app-icon>
      </label>
    </div>
    <div class="radio-option-arrow">
      <input type="radio" id="Exact amount" name="home-cost" value="Exact amount" (click)="toggleEdit()" />
      <label for="Exact amount">
        Exact amount
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="bold" fontSize="22">right</app-icon>
      </label>
    </div>
  </div>
  <p class="chat-answer" answer *ngIf="!editMode">{{homeWorth}}</p>

  <p question *ngIf="editMode">Sounds good!</p>
  <p class="desc" question *ngIf="editMode && journeyType === FelloOfferJourneyType.LWF;">
    <br />We'll connect you with highly-rated agents who specialize in homes like yours!<br />
  </p>
  <p class="desc" question *ngIf="editMode"><br />How much do you think the home is worth?</p>
  <form input-options #exactAmount="ngForm" *ngIf="editMode">
    <div class="form-field prefix" input-options data-prefix="$">
      <lib-amount-comma-separated
        class="text-right"
        placeholder="0"
        required
        name="cost"
        (keyup.enter)="exactAmount?.valid && submit(homeWorthExactAmount)"
        [(ngModel)]="homeWorthExactAmount"
        [libMin]="10000"
        [libMax]="100000000"
      ></lib-amount-comma-separated>
    </div>
  </form>
  <p class="chat-answer" answer *ngIf="editMode">{{homeWorthExactAmount | currency :'USD' : 'symbol' : '1.0-0'}}</p>
  <div class="buttons-c mt-auto" input-options>
    <button *ngIf="editMode" class="w-100" (click)="submit(homeWorthExactAmount)" [disabled]="exactAmount?.invalid">Continue</button>
    <button *ngIf="editMode && approxHomeWorth" class="w-100 button-primary" (click)="toggleEdit()">Select range</button>
  </div>
</app-question-card>
